import React, { useState } from 'react';
import { Play, LayoutDashboard, Calendar, X } from 'lucide-react';

const FloatingActionButton = ({ onPlayStory, onDashboard, onTimeline }) => {
  const [isOpen, setIsOpen] = useState(false);

  const actions = [
    { icon: Play, label: 'Play Story', onClick: onPlayStory, color: 'bg-purple-500' },
    { icon: LayoutDashboard, label: 'Dashboard', onClick: onDashboard, color: 'bg-blue-500' },
    { icon: Calendar, label: 'Timeline', onClick: onTimeline, color: 'bg-green-500' },
  ];

  const handleActionClick = (onClick) => {
    onClick();
    setIsOpen(false);
  };

  return (
    <div className="fixed bottom-24 right-6 z-50">
      {/* Action Buttons */}
      {isOpen && (
        <div className="absolute bottom-16 right-0 flex flex-col gap-3 mb-2">
          {actions.map((action, index) => (
            <button
              key={index}
              onClick={() => handleActionClick(action.onClick)}
              className={`${action.color} hover:opacity-90 text-white rounded-full p-4 shadow-lg transition-all transform hover:scale-110 flex items-center gap-2 group`}
              style={{
                animation: `slideUp 0.3s ease-out ${index * 0.1}s both`
              }}
            >
              <action.icon className="w-5 h-5" />
              <span className="text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
                {action.label}
              </span>
            </button>
          ))}
        </div>
      )}

      {/* Main FAB */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`bg-gradient-to-br from-cosmic-500 to-sacred-500 hover:from-cosmic-600 hover:to-sacred-600 text-white rounded-full p-4 shadow-2xl transition-all transform hover:scale-110 ${
          isOpen ? 'rotate-45' : ''
        }`}
      >
        {isOpen ? <X className="w-6 h-6" /> : <Play className="w-6 h-6" />}
      </button>

      <style jsx>{`
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default FloatingActionButton;